<template>
	<transition>
		<div class="preloader" name="fade">
			<div class="logo"></div>
			<p>hello world</p>
		</div>
	</transition>
</template>

<script>
export default {
	name: "preloader",
};
</script>
